module.exports = __webpack_public_path__ + "img/1.0a9df46e.png";